import classnames from "classnames";
import styles from "./UserInfo.module.scss";

const UserInfo = ({ src, name, className }) => {
  return (
    <>
      {src && (
        <img
          className={classnames(styles.photo, className)}
          src={src}
          alt={name}
        />
      )}
      {name}
    </>
  );
};

export default UserInfo;
